import { animate, AnimationTriggerMetadata, query, stagger, style, transition, trigger } from '@angular/animations';

export const animations: AnimationTriggerMetadata[] = [
  trigger('flyIn', [
    transition('void => *', [
      query('.news', [
        style({transform: 'translateY(-10%)', opacity: 0}),
        stagger(200, [
          animate(300, style({transform: 'translateY(0%)', opacity: 1})),
        ]),
      ], { optional: true }),
    ]),
  ])
];



// WEBPACK FOOTER //
// ./src/app/magazine/magazine-news/magazine-news.animations.ts